const Footer = () => {
    return (
        <footer className="text-center p-4 bg-slate-800">
            <p className="text-sm text-white">&copy; {new Date().getFullYear()} Locgram - Todos os Direitos Reservados</p>
        </footer>
    );
};

export default Footer;